<template>
  <div id="page-recording-details" class="data-list-container">
    <vx-card v-show="pageLoaded" class="details-page">
      <div slot="no-body" class="tabs-container">
        <div class="head-tab-bar">
          <span
            ><strong> {{ programName }}</strong></span
          >
        </div>
        <vs-tabs v-model="activeTab">
          <vs-tab label="Gravação" icon-pack="feather" icon="icon-video">
            <div class="tab-text">
              <recording-details-tab-recording class="mt-4" :data="recording" />
            </div>
          </vs-tab>
          <vs-tab label="Público" icon-pack="feather" icon="icon-users">
            <div class="tab-text">
              <recording-details-tab-public
                class="mt-4"
                :data="{ itemsPerPage, page, recordingId, recording }"
              />
            </div>
          </vs-tab>
          <vs-tab label="Caravanistas" icon-pack="feather" icon="icon-users">
            <div class="tab-text">
              <recording-details-tab-caravanists
                class="mt-4"
                :data="caravanists"
              />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import RecordingDetailsTabRecording from "./RecordingDetailsTabRecording.vue";
import RecordingDetailsTabCaravanists from "./RecordingDetailsTabCaravanists.vue";
import RecordingDetailsTabPublic from "./RecordingDetailsTabPublic.vue";
import moduleRecording from "@/store/recording/moduleRecording.js";

export default {
  components: {
    RecordingDetailsTabRecording,
    RecordingDetailsTabCaravanists,
    RecordingDetailsTabPublic,
  },
  data() {
    return {
      activeTab: 0,
      programName: "",
      pageLoaded: true,
      itemsPerPage: 50, // participants
      page: 1,
    };
  },
  computed: {
    recordingId() {
      return this.$route.params.id;
    },
    recording() {
      return Object.assign({}, this.$store.state.recording.single);
    },
    caravanists() {
      return this.$store.state.recording.caravanists;
    },
    participants() {
      return this.$store.state.recording.participants;
    },
  },
  methods: {
    removeLoading() {
      this.$vs.loading.close("#page-recording-details .con-vs-loading");
      this.pageLoaded = true;
    },
  },
  created() {
    if (!moduleRecording.isRegistered) {
      this.$store.registerModule("recording", moduleRecording);
      moduleRecording.isRegistered = true;
    }
  },
  mounted() {
    this.$vs.loading({
      container: "#page-recording-details",
      scale: 0.6,
    });

    this.$store
      .dispatch("recording/fetchRecordingById", {
        recordingId: this.$route.params.id,
      })
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.recording &&
          res.data.recording.program
        ) {
          this.programName = res.data.recording.program.name;
        }
      })
      .finally(() => {
        this.removeLoading();
      });

    this.$store
      .dispatch("recording/fetchCaravanists", {
        recordingId: this.$route.params.id,
      })
      .finally(() => {});

    this.$store
      .dispatch("recording/fetchParticipants", {
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        recordingId: this.$route.params.id,
      })
      .finally(() => {});
  },
};
</script>

<style lang="scss">
button.vs-tabs--btn {
  display: flex;
  flex-direction: column;
  margin-right: 2px;
}
button.vs-tabs--btn i {
  font-size: 20px;
}

.head-tab-bar {
  background: #fff;
  padding: 4px 10px;
}

.con-ul-tabs {
  overflow-y: hidden;
  overflow-x: auto;
}
.details-page {
  .con-vs-tabs,
  .con-slot-tabs {
    overflow: visible;
  }
  &.vx-card {
    background-color: transparent;
    box-shadow: none;
  }
  .vx-row {
    margin: 0;
  }
  .con-ul-tabs,
  .vs-tabs--ul {
    z-index: 2;
    background: #fff;
    box-shadow: none;
  }
  .con-tab {
    padding: 23px 0;
    margin: -37px 0 0 0;
    z-index: 1;
  }
  .mb-base {
    border-radius: 0 0 0.5rem 0.5rem;
    .vx-col {
      padding: 0;
    }
    ~ .vx-row.w-full {
      .vx-col {
        padding: 0 0 0 1em;
      }
      .vx-col:first-child {
        padding: 0 1em 0 0;
      }
    }
  }
  .vx-col {
    table {
      width: 100%;
      td {
        width: 50%;
      }
    }
  }
  @media (max-width: 689px) {
    .mb-base {
      ~ .vx-row.w-full {
        .vx-col,
        .vx-col:first-child {
          padding: 0;
          + .vx-col {
            margin-top: 1em;
          }
        }
      }
    }
  }
}
</style>
